import type { SVGProps } from 'react'
const LineChevronRightSmall = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="m9.78 18.78-1.06-1.06L14.44 12 8.72 6.28l1.06-1.06 5.895 5.895c.485.485.485 1.28 0 1.77z"
		/>
	</svg>
)
export { LineChevronRightSmall }
